<template>
    <div :class="[{ 'opacity-background': show }]">
        <header>
            <div class="navbar-fixed">
                <nav class="header-contractor-mobile">
                    <div @click="$emit('show')" :class="['nav-icon', { open: show }]">
                        <div></div>
                    </div>
                    <a
                        @click="$emit('push-route', { url: 'LandingPage', solo: false })"
                        class="brand-logo-contractor-mobile"
                    >
                        <img :src="logo" class="center-element" alt="Engelink" />
                        <img
                            height="28px"
                            style="margin-left: 15px; border-left: 1px solid #707070; padding-left: 10px"
                            v-if="showPartnerLogo"
                            src="@/assets/images/cipa-logo.svg"
                            alt="Engelink"
                        />
                    </a>
                </nav>
            </div>
            <div :class="['side-bar-mobile', { show: show }]">
                <ul>
                    <li>
                        <a @click="$emit('push-route', { url: 'ListCompetitions', solo: false })">
                            <span class="title-mobile">Minhas cotações</span>
                        </a>
                    </li>

                    <li>
                        <a @click="$emit('push-route', { url: 'NetworkSuppliers', solo: false })">
                            <span class="title-mobile">Guia de Fornecedores</span>
                        </a>
                    </li>

                    <li>
                        <a @click="$emit('push-route', { url: 'https://condo.news/', solo: true })">
                            <span class="title-mobile"> CondoNews </span>
                        </a>
                    </li>

                    <li>
                        <a @click="$emit('push-route', { url: 'https://pages.engelink.com.br/materiais', solo: true })">
                            <span class="title-mobile"> Materiais </span>
                        </a>
                    </li>

                    <li v-show="!isCondoAdministrator && !isRequester">
                        <a @click="$emit('push-route', { url: 'EditProfile', solo: false })">
                            <span class="title-mobile">Editar perfil</span>
                        </a>
                    </li>
                    <li>
                        <a @click="$emit('push-route', { url: 'ContactUs', solo: false })">
                            <span class="title-mobile">Fale conosco</span>
                        </a>
                    </li>
                    <li v-show="!isCondoAdministrator && !isRequester">
                        <a
                            @click="$emit('push-route', { url: 'Home', solo: false, queryString: { redirect: false } })"
                        >
                            <span class="title-mobile">Alterar perfil</span>
                        </a>
                    </li>
                    <li>
                        <a @click="$emit('logout')">
                            <span class="title-mobile">Sair</span>
                        </a>
                    </li>
                </ul>
            </div>
        </header>
    </div>
</template>

<script>
// Módulos
import { mapState } from 'vuex';
export default {
    name: 'HeaderContractorMobile',
    props: {
        show: Boolean,
        showPartnerLogo: Boolean,
        logo: String
    },
    computed: {
        ...mapState('user', ['user']),
        isCondoAdministrator () {
            return this.user.type ? this.user.type.isCondoAdministrator : false;
        },
        isRequester () {
            return this.user.type ? this.user.type.isRequester : false;
        }
    }
};
</script>

<style lang="scss">
li {
    list-style-type: none;
}
.header-contractor-mobile {
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    z-index: 999 !important;
    box-shadow: 0px 3px 6px #00000029;
}
nav .brand-logo-contractor-mobile {
    align-items: center;
    display: flex;
    flex-direction: row;
    font-size: 1.6rem;
    height: 54px;
    justify-content: center;
    width: 150px;
}
nav .brand-logo-contractor-mobile img {
    max-height: 40px;
    max-width: 150px;
}
/* // Tracinho de cima */
.nav-icon:before {
    width: 35px;
}
/* // Tracinho do meio */
.nav-icon {
    /* // margin: 1em; */
    left: 0;
    position: fixed;
    width: 30px;
    margin-left: 25px;
    align-self: center;
}
/* // Tracinho de baixo */
.nav-icon:after {
    width: 25px;
}
.nav-icon:after,
.nav-icon:before,
.nav-icon div {
    background-color: #003f7e;
    border-radius: 3px;
    content: "";
    display: block;
    height: 4px;
    margin: 4px 0;
    transition: all 0.4s ease-in-out;
}
/* // largura quando o menu está aberto */
.nav-icon.open:after,
.nav-icon.open:before,
.nav-icon.open {
    width: 20px !important;
    padding-left: 0px !important;
}
.nav-icon.open:before {
    transform: translateY(12px) rotate(135deg);
}

.nav-icon.open:after {
    transform: translateY(-12px) rotate(-135deg);
}

.nav-icon.open div {
    transform: scale(0);
}
.side-bar-contractor-mobile {
    box-shadow: inset 0 0 2px black;
    text-align: justify;
    position: fixed;
    height: 100%;
    width: 0%;
    z-index: 9999 !important;
    background-color: #fff;
    color: #000;
    transition: 0.5s;
    overflow: hidden;
    box-shadow: black;
}
.side-bar-contractor-mobile.show {
    width: 80%;
}
.side-bar-contractor-mobile ul {
    /* // position: absolute; */
    top: 0;
    left: 0;
    width: 100%;
}
.side-bar-contractor-mobile ul li {
    position: relative;
    width: 100%;
    list-style: none;
}
.side-bar-contractor-mobile ul li a .title-mobile {
    position: relative;
    display: block;
    padding: 0 10px;
    text-align: start;
    white-space: nowrap;
}
.side-bar-contractor-mobile ul li a {
    position: relative;
    display: block;
    width: 100%;
    /* // display: flex; */
    text-decoration: none;
    padding: 13px 16px 13px 16px;
    text-decoration: none;
    font-size: 16px;
    color: #707070;
}
.side-bar-contractor-mobile.show {
    width: 80%;
}
/* efeito de opacidade do menu de fornecedor na versão mobile */
.opacity-background {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
    display: table;
    transition: 0.5s;
    overflow: hidden;
}
</style>
